import { struct } from 'io-ts/Decoder';

import { WholeHouseId as WholeHouseAncillaryItemId } from '../../../job/ancillary-item';
import { Id as OrganizationId } from '../../../organization/Id';

export const Request = struct({
	organizationId: OrganizationId,
	takeoffType: WholeHouseAncillaryItemId,
});
